import React, { Fragment } from "react";
import PropTypes from "prop-types";
import OverlayComponent from "../overlay";
import "./styles.css";

const NosotrosComponent = (props) => {
  const desenfoque = (status) => {
    if (status) {
      const videoFondo = document.getElementById("fondo-video");
      videoFondo.style.filter = "blur(0px)";
    } else {
      const videoFondo = document.getElementById("fondo-video");
      videoFondo.style.filter = "blur(20px)";
    }
  };
  return (
    <Fragment>
      <div id="nosotros-container" className="nosotros-container">
        <OverlayComponent
          cambiarIdioma={props.cambiarIdioma}
          componente={props.componente}
          hover={desenfoque}
          array={props.manifiesto}
        ></OverlayComponent>
      </div>
    </Fragment>
  );
};

NosotrosComponent.propTypes = {
  manifiesto: PropTypes.array,
  componente: PropTypes.string,
  cambiarIdioma: PropTypes.bool,
};

export default NosotrosComponent;
